import { render } from "./upgrade-modal.vue?vue&type=template&id=6f081cb2&ts=true"
import script from "./upgrade-modal.vue?vue&type=script&lang=ts"
export * from "./upgrade-modal.vue?vue&type=script&lang=ts"

import "./upgrade-modal.vue?vue&type=style&index=0&id=6f081cb2&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__